import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { roleGuard } from './common/guards/roleGuard';

const routes: Routes = [
  {
    path: 'projects/:projectId',
    loadChildren: () => import('./invoices/invoices.module').then((m) => m.InvoicesModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'invoices',
    loadChildren: () => import('./invoices/invoices.module').then((m) => m.InvoicesModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'all-invoices',
    loadChildren: () => import('./invoices-list/invoices-list.module').then((m) => m.InvoicesListModule),
    canActivate: [authGuard],
  },
  {
    path: 'recipients',
    loadChildren: () => import('./recipients/recipients.module').then((m) => m.RecipientsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'products',
    loadChildren: () => import('./products/products.module').then((m) => m.ProductsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'clients',
    loadChildren: () => import('./clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then((m) => m.EventsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'playground',
    loadChildren: () => import('./playground/playground.module').then((m) => m.PlaygroundModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'organizations',
    loadChildren: () => import('./organizations/organizations.module').then((m) => m.OrganizationsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'memberships',
    loadChildren: () => import('./memberships/memberships.module').then((m) => m.MembershipsModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'company-settings',
    loadChildren: () => import('./companies/company.module').then((m) => m.CompanyModule),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'auth/callback',
    loadComponent: () => import('./auth/auth-callback/auth-callback.component').then((m) => m.AuthCallbackComponent),
  },
  {
    path: 'set-password',
    loadComponent: () => import('./auth/set-password/set-password.component').then((m) => m.SetPasswordComponent),
  },
  {
    path: '',
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [authGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
